import "./page-roi-calculator.scss";
import "../../js/core";

$(function () {
  import(
    /* webpackChunkName: "chunk.owl-carousel" */ "owl.carousel/src/js/owl.carousel"
  ).then(() => {
    import(
      /* webpackChunkName: "chunk.owl-carousel-navigation" */ "owl.carousel/src/js/owl.navigation"
    ).then(() => {
      $(".slider-card-blog").owlCarousel({
        responsive: {
          0: {
            items: 1,
            dots: false,
          },
          768: {
            items: 2,
            dots: false,
          },
          992: {
            items: 3,
          },
        },
        loop: false,
        nav: true,
        dots: true,
        slideBy: 1,
        margin: 20,
        smartSpeed: 200,
      });

      $(".owl-carousel").each(function (index) {
        $(this)
          .find(".owl-nav, .owl-dots")
          .wrapAll("<div class='owl-controls'></div>");
      });
    });
  });
});

$(document).ready(function () {
  let fieldNumber = $(".section-calculator input[type=number]");
  let fieldFarmingArea = $(".section-calculator input[name=farming-area]");
  let fieldLastYeild = $(".section-calculator input[name=last-yield]");
  let fieldMarketPrices = $(".section-calculator input[name=market-prices]");
  let ValidationText = $(".section-calculator .form").data("error-message");
  var buttonCalculateIsActive = false;

  localStorage.setItem("hideROIPopup", "true");

  function validateInput(event) {
    const input = $(event.target);
    const value = input.val() + event.key;

    // Запрет на ввод точки первым символом
    if (value === "." || value.startsWith("..")) {
      event.preventDefault();
      return;
    }

    if (/^0\d/.test(value) && !value.startsWith("0.")) {
      event.preventDefault();
      return;
    }

    const regex = /^\d*\.?\d{0,2}$/;

    if (!regex.test(value) || event.key === "-") {
      event.preventDefault();
    }
  }

  fieldNumber.on("keypress", validateInput);

  fieldNumber.on("paste", function (event) {
    const clipboardData =
      event.originalEvent.clipboardData || window.clipboardData;
    const pastedData = clipboardData.getData("Text");

    if (!/^\d*\.?\d{0,2}$/.test(pastedData)) {
      event.preventDefault();
    }
  });
  fieldNumber.on("blur", function (event) {
    let value = $(this).val();

    if (value < 0.01) {
      $(this).val("");
    }
  });

  $("#CalculateButton").on("click", function () {
    let formHasError;

    fieldNumber.each(function () {
      let thisFieldValue = $(this).val();

      if (!thisFieldValue) {
        formHasError = true;
        $(this).parent().addClass("has-error");
        $(this).next("span").remove();
        $(this).after(`<span class="validation-text">${ValidationText}</span>`);
      } else {
        $(this).parent().removeClass("has-error");
        $(this).next("span").remove();
      }
    });

    if (formHasError !== true) {
      let annualInvestvent = Number(fieldFarmingArea.val()) * 1.5;
      let potentionalProfit =
        0.1 *
        Number(fieldFarmingArea.val()) *
        (0.1 * Number(fieldLastYeild.val()) * Number(fieldMarketPrices.val()));
      let potentionalROI = Math.round(
        (Math.round(potentionalProfit) / Math.round(annualInvestvent)) * 100
      );

      buttonCalculateIsActive = true;

      $("#AnnualInvestvent").text(Math.round(annualInvestvent));
      $("#PotentionalProfit").text(Math.round(potentionalProfit));
      $("#PotentionalROI").text(potentionalROI);

      if (Number(fieldFarmingArea.val()) >= 5000) {
        $(".section-calculator .show-link").hide();
        $(".section-calculator .show-form").show();
      } else {
        $(".section-calculator .show-form").hide();
        $(".section-calculator .show-link").show();
      }

      let elTopOffset = $(".result-show-button").offset().top;
      let elHeight = $(".result-show-button").height();
      let windowHeight = $(window).height();
      let scrollTop = $(window).scrollTop();

      if (elTopOffset + elHeight > scrollTop + windowHeight) {
        $("html, body").animate(
          {
            scrollTop: elTopOffset - windowHeight + elHeight,
          },
          200
        );
      }
    }
  });

  fieldNumber.each(function () {
    $(this).on("input", function () {
      let formHasError;
      if (buttonCalculateIsActive) {
        let thisFieldValue = $(this).val();

        if (!thisFieldValue) {
          formHasError = true;
          $(this).parent().addClass("has-error");
          $(this).next("span").remove();
          $(this).after(
            `<span class="validation-text">${ValidationText}</span>`
          );
        } else {
          $(this).parent().removeClass("has-error");
          $(this).next("span").remove();
        }

        if (formHasError !== true) {
          let annualInvestvent = Number(fieldFarmingArea.val()) * 1.5;
          let potentionalProfit =
            0.1 *
            Number(fieldFarmingArea.val()) *
            (0.1 *
              Number(fieldLastYeild.val()) *
              Number(fieldMarketPrices.val()));
          let potentionalROI = Math.round(
            (Math.round(potentionalProfit) / Math.round(annualInvestvent)) * 100
          );

          $("#AnnualInvestvent").text(Math.round(annualInvestvent));
          $("#PotentionalProfit").text(Math.round(potentionalProfit));
          $("#PotentionalROI").text(potentionalROI);

          if (Number(fieldFarmingArea.val()) >= 5000) {
            $(".section-calculator .show-link").hide();
            $(".section-calculator .show-form").show();
          } else {
            $(".section-calculator .show-form").hide();
            $(".section-calculator .show-link").show();
          }
        }
      }
    });
  });
});
